<template>
  <div>
    <avue-crud :option="option" :table-loading="tableLoading" :data="tableData" :page="page" v-model="modelForm"
      ref="crud" @search-change="searchChange" @search-reset="searchReset" @current-change="currentChange"
      @size-change="sizeChange" @on-load="onLoad" @refresh-change="refresh">
      <template slot="menuLeft">
        <div class="my-head">
          <span height="30">流程节点</span>
        </div>

      </template>
      <!--操作栏目-->
      <template slot-scope="{type,size,row}" slot="menu">
        <!-- 跳转按钮 -->
        <el-tooltip v-if="!row.endTime && row.activityType === 'userTask'" content="跳转" placement="bottom"
          effect="light">
          <el-button circle @click="jumpTask(row)" :size="size" :type="type" icon="el-icon-upload2"></el-button>
        </el-tooltip>
        <!-- 转办按钮 -->
        <el-tooltip v-if="!row.endTime && row.activityType === 'userTask'" content="转办" placement="bottom"
          effect="light">
          <el-button circle @click="turnTask(row)" :size="size" :type="type" icon="el-icon-right"></el-button>
        </el-tooltip>
        <!-- 变量设置 -->
        <el-tooltip v-if="!row.endTime && row.activityType === 'userTask'" content="变量设置" placement="bottom"
          effect="light">
          <el-button circle @click="setVariable(row)" :size="size" :type="type" icon="el-icon-setting"></el-button>
        </el-tooltip>
      </template>
    </avue-crud>
    <el-dialog :title="changeTaskInfo.title" :visible.sync="changeTaskInfo.dialogVisible" :width="300"
      append-to-body="true">

      <el-form ref="changeTaskInfo" :model="changeTaskInfo.form" label-suffix=":" label-position="left"
        label-width="120px">
        <el-row>
          <!-- 选择一个用用户-->
          <el-form-item v-if="changeTaskInfo.changeType==='turn'" label="接手人" prop="acceptUser"
            :rules="[{ 'required': true, 'message': `请选择接手人` },{validator:acceptUserValidator , trigger: 'blur'}]">
            <flowUserSelect v-model="changeTaskInfo.form.acceptUser" @focus="inputFocus"></flowUserSelect>
          </el-form-item>
          <el-col v-if="changeTaskInfo.changeType==='turn'" :span="23">
            <el-form-item label="转办原因" prop="reason" :rules="[{ 'required': true, 'message': `请输入转办原因`}]">
              <el-input type="textarea" rows="7" v-model="changeTaskInfo.form.reason"
                :placeholder="`请输入转办原因`"></el-input>
            </el-form-item>
          </el-col>
          <el-form-item v-if="changeTaskInfo.changeType==='jump'" label="跳转到" prop="newTaskDefKeys"
            :rules="[{ 'required': true, 'message': `请选择跳转环节`}]">
            <el-select v-model="changeTaskInfo.form.newTaskDefKeys" clearable placeholder="请选择跳转环节">
              <el-option v-for="item in changeTaskInfo.form.taskArr" :key="item.id" :label="item.taskName"
                :value="item.taskDefKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-col v-if="changeTaskInfo.changeType==='setVariable'" :span="23">

            <el-form-item label="变量名称" prop="variableName" :rules="[{ 'required': true, 'message': `请输入变量名`}]">
              <el-input type="input" v-model="changeTaskInfo.form.variableName" :placeholder="`请输入变量名`"></el-input>
            </el-form-item>
            <el-form-item label="变量值" prop="variableValue" :rules="[{ 'required': true, 'message': `请输入变值`}]">
              <el-input type="input" v-model="changeTaskInfo.form.variableValue" :placeholder="`请输入变值`"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="changeTaskInfo.dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="changeTask">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dateFormat } from '@/framework/util/date'
import flowUserSelect from '@/workFlow/formComponent/viewForm/flowUserSelect.vue'
export default {
  props: ['processInstanceId'],
  data() {
    return {
      acceptUserValidator: (rule, value, callback) => {
        if (typeof value === 'string') {
          callback()
        } else {
          value && value.id ? callback() : callback(new Error(`您必须选择一项...`))
        }
      },
      changeTaskInfo: {
        title: '转办/跳转',
        dialogVisible: false,
        changeType: '',
        form: {
          acceptUser: {},
          reason: '',
          taskId: '',
          currentTaskDefKeys: '',
          taskArr: [],
          newTaskDefKeys: ''
        }
      },
      tableLoading: false,
      tableData: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      query: {},
      order: {
        oder: '',
        prop: ''
      },
      modelForm: {},
      option: {
        border: true,
        page: false,
        index: true,
        height: '300',
        align: 'center',
        menuAlign: 'center',
        searchMenuSpan: 4,
        addBtn: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        refreshBtn: false,
        columnBtn: false,
        menuType: 'icon',
        stripe: true,
        column: [
          {
            label: '节点id',
            prop: 'id',
            hide: true,
            editDisabled: true
          },
          {
            label: '节点key',
            prop: 'activityId',
            hide: true,
            editDisabled: true
          },
          {
            label: '节点名称',
            prop: 'activityName',
            editDisabled: true
          },
          {
            label: '节点类型',
            prop: 'activityType',
            editDisabled: true
          },
          {
            prop: 'startTime',
            label: '开始时间',
            formatter: (row, value) => dateFormat(new Date(value)),
            type: 'input'
          },
          {
            prop: 'endTime',
            label: '结束时间',
            formatter: (row, value) => value ? dateFormat(new Date(value)) : '',
            type: 'input'
          },
          {
            prop: 'durationInMillis',
            label: '耗时(ms)',
            type: 'input'
          },
          {
            prop: 'assigneeName',
            label: '执行人/完成人',
            type: 'input'
          }
        ]
      }
    }
  },

  components: { flowUserSelect },

  methods: {
    turnTask(row) {
      this.changeTaskInfo = {
        title: '转办',
        dialogVisible: true,
        changeType: 'turn', // turn 或者 jump
        form: {
          taskId: row.taskId,
          acceptUser: {},
          reason: '',
          currentTaskDefKeys: row.activityId,
          taskArr: [],
          newTaskDefKeys: ''
        }
      }
    },
    setVariable(row) {
      this.changeTaskInfo = {
        title: '设置变量',
        dialogVisible: true,
        changeType: 'setVariable', // setVariable、turn 或者 jump
        form: {
          taskId: row.taskId,
          variableName: '',
          variableValue: ''
        }
      }
    },
    jumpTask(row) {
      // currentTaskDefKeys = row.activityId
      // row.processDefinitionId
      // /flow-monitor/process-definition-task-list
      // 流程定义环节列表
      this.changeTaskInfo = {
        title: '跳转',
        dialogVisible: true,
        changeType: 'jump', // turn 或者 jump
        form: {
          taskId: row.taskId,
          acceptUser: {},
          reason: '',
          currentTaskDefKeys: row.activityId,
          taskArr: [],
          newTaskDefKeys: ''
        }
      }
      this.$http.get('/flow-monitor/process-definition-task-list', {
        params: {
          processDefinitionId: row.processDefinitionId
        }
      }).then(
        response => {
          this.changeTaskInfo.form.taskArr = response.data
        }
      ).catch(
        error => {
          this.$message.error(error.msg || error.message)
        }
      )
    },
    changeTask() {
      this.$refs.changeTaskInfo.validate((valid) => {
        if (valid) {
          if (this.changeTaskInfo.changeType === 'turn') {
            this.$http.put('/flow-task-change/turn-task', [], {
              params: {
                acceptUserId: this.changeTaskInfo.form.acceptUser.id,
                turnTaskReason: this.changeTaskInfo.form.reason,
                taskId: this.changeTaskInfo.form.taskId
              }
            }).then(res => {
              if (res.code === 200) {
                this.changeTaskInfo.dialogVisible = false
                this.onLoad()
              } else {
                this.$message.error(res.msg)
              }
            }).catch(err => {
              this.$message.error(err.msg)
            })
          } else if (this.changeTaskInfo.changeType === 'jump') {
            // 跳转
            // flow-task-change/jump currentTaskDefKeys newTaskDefKeys processInstanceId
            this.$http.put('/flow-task-change/jump', [], {
              params: {
                newTaskDefKeys: this.changeTaskInfo.form.newTaskDefKeys,
                processInstanceId: this.processInstanceId,
                currentTaskDefKeys: this.changeTaskInfo.form.currentTaskDefKeys
              }
            }).then(res => {
              if (res.code === 200) {
                this.changeTaskInfo.dialogVisible = false
                this.onLoad()
              } else {
                this.$message.error(res.msg)
              }
            }).catch(err => {
              this.$message.error(err.msg)
            })
          } else {
            let variableValue = this.changeTaskInfo.form.variableValue
            let variableName = this.changeTaskInfo.form.variableName
            if (variableValue.indexOf('{') >= 0 || variableValue.indexOf('[') >= 0) {
              try {
                variableValue = JSON.parse(variableValue)
              } catch (e) {
                console.log(e.message)
              }
            }
            let bodyParams = {}
            bodyParams[variableName] = variableValue
            this.$http.put('/flow-task-change/set-variable', bodyParams, {
              params: {
                taskId: this.changeTaskInfo.form.taskId
              }
            }).then(res => {
              if (res.code === 200) {
                this.changeTaskInfo.dialogVisible = false
                this.$message.success('设置成功')
              } else {
                this.$message.error(res.msg)
              }
            }).catch(err => {
              this.$message.error(err.msg)
            })
          }
        }
      })
    },
    onLoad(page = this.page, params = this.query, order = this.order) {
      let processInstanceId = this.processInstanceId
      if (!processInstanceId) {
        this.tableData = []
        this.page.total = 0
        return
      }
      this.tableLoading = true
      this.$http.get('/flow-monitor/process-task-list', {
        params: {
          processInstanceId: processInstanceId
        }
      }).then(
        response => {
          this.tableLoading = false
          this.tableData = response.data
          // this.page.total = response.data.total || response.data.records.length
        }
      ).catch(
        error => {
          this.tableLoading = false
          this.$message.error(error.msg || error.message)
        }
      )
    },
    // 搜索改变事件
    searchChange(params, done) {
      for (let key in params) {
        if (params[key] === '') delete params[key]
      }
      done()
      this.page.currentPage = 1
      this.query = params
      this.onLoad()
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.onLoad()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refresh: function () {
      this.onLoad()
    }
  }
}

</script>
<style lang='scss' scoped>
:deep(.avue-crud__menu) {
  margin-bottom: 0;
  height: 30px !important;
  min-height: 30px;
}
:deep(.avue-crud__left) {
  width: 100% !important;
  height: 30px !important;
}
.my-head {
  background-color: #3b9cd9;
  padding: 0 10px;
  width: 100%;
  height: 100%;
  line-height: 30px;
}
.my-head span {
  color: #ffffff;
  font-weight: 500;
  font-size: 18px;
}
</style>
